import { Table } from "antd";

export const EksNodeGroupPanel = (data) => {
  const nodeGroups = data?.data.nodegroups;
  const columns = [
    {
      title: 'Group Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Desired Size',
      dataIndex: 'desiredSize',
      key: 'desiredSize'
    },
    {
      title: 'Version',
      dataIndex: 'version',
      key: 'version'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status'
    }
  ];
  return (
    <Table dataSource={nodeGroups} columns={columns}/>
  );
}; 